import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { Gender } from "../../../../../enums/GenderEnum";
import { PermissionManager } from "../../../../../common/utilities/permission-manager";
import { NavigationService } from "../../../../../services/navigation.service";
import { ParentPermissionEnum } from "../../../../../enums/ParentPermissionEnum";
import { PermissionActionEnum } from "../../../../../enums/PermissionActionEnum";
import { AnalyticsCategory } from "../../../../../services/analytics.service";
import { ApplicationEnum } from "../../../../../enums/ApplicationEnum";

import EmptyTextHandler from "../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";

export default defineComponent({
    components: {
        EmptyTextHandler
    },
    props: {
        selectedPatientDetails: {
            default: null
        },
        patientRiskDetails: {
            default: null
        },
        patientDetails: {
            default: null
        }
    },
    data(vm) {
        return {
            _permissionManager: null as PermissionManager,
            _navigationService: null as NavigationService,
            genderEnum: Gender,
            patientTags: "" as string,
            hasAddress: false as boolean,
            patientAddressLink: "" as string
        };
    },
    created() {
        this._permissionManager = Container.instance.get(PermissionManager);
        this._navigationService = Container.instance.get(NavigationService);
        if (this.selectedPatientDetails.PatientTags) {
            this.patientTags = this.selectedPatientDetails.PatientTags?.map((tag) => tag.name).join(", ");
        }
    },
    mounted() {
        this.hasAddress =
            !!this.selectedPatientDetails.AddressLine1 &&
            !!this.selectedPatientDetails.AddressCity &&
            !!this.selectedPatientDetails.AddressStateCode;
    },
    computed: {
        address(): string {
            let addressLine1 = this.selectedPatientDetails?.AddressLine1?.trim() || "";
            let addressLine2 = this.selectedPatientDetails?.AddressLine2?.trim() || "";
            let city =
                this.selectedPatientDetails?.AddressCity?.charAt(0).toUpperCase() +
                    this.selectedPatientDetails?.AddressCity?.substr(1).toLowerCase() || "";
            let stateCode = this.selectedPatientDetails?.AddressStateCode || "";
            let zipcode = this.selectedPatientDetails?.AddressZipCode || "";
            this.patientAddressLink = `https://www.google.com/maps/place/${this.selectedPatientDetails.AddressLine1 || ""},${
                this.selectedPatientDetails.AddressCity || ""
            },${this.selectedPatientDetails.AddressStateCode || ""}`;
            return `${addressLine1}${addressLine2 ? " " + addressLine2 : ""}, ${city}, ${stateCode} ${zipcode}`;
        },
        age(): string {
            if (this.selectedPatientDetails.DOB) {
                let today = new Date();
                let birthDate = new Date(this.selectedPatientDetails.DOB);
                let age = today.getFullYear() - birthDate.getFullYear();
                let month = today.getMonth() - birthDate.getMonth();
                if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
                    (age--).toString();
                }
                return age.toString();
            }
            return "";
        },
        dobString(): string {
            return this.age ? `${this.selectedPatientDetails?.DOBFormatted} (${this.age})` : "";
        }
    },
    methods: {
        async handlePatientNameClick() {
            const isClinician = this._permissionManager.checkPermission(
                ParentPermissionEnum.clinician,
                PermissionActionEnum.canView
            );
            let redirectResponse = await this._navigationService.navigateToPatient({
                agencyId: this.selectedPatientDetails.AgencyId,
                applicationId: ApplicationEnum.AgencyCore,
                isClinician: isClinician,
                patientId: this.selectedPatientDetails.Id
            });
            let action = "AxxessHomeHealth";
            this._navigationService.redirectOnNewTab(redirectResponse, {
                category: AnalyticsCategory.CentralCalendarNavigation,
                action
            });
        }
    }
});
